import { WishlistActions } from './actions';

export interface IWishlistState {
    itemKeys: Record<string, boolean>;
    fingerprint: string | null;
    remoteSyncNonce: number;
    /** True while loading the full list (e.g. initial fetch). */
    loading: boolean;
    /** Set only while add/remove for that master+color is in flight — avoids disabling every wishlist icon. */
    mutatingKey: string | null;
}

const initialState: IWishlistState = {
    itemKeys: {},
    fingerprint: null,
    remoteSyncNonce: 0,
    loading: false,
    mutatingKey: null,
};

export default (state = initialState, action: WishlistActions): IWishlistState => {
    switch (action.type) {
        case 'WISHLIST_FETCH_START':
            return { ...state, loading: true };
        case 'WISHLIST_MUTATE_START':
            return { ...state, mutatingKey: action.payload.key };
        case 'WISHLIST_FETCH_SUCCESS':
            return {
                ...state,
                loading: false,
                mutatingKey: null,
                itemKeys: action.payload.itemKeys,
                fingerprint: action.payload.fingerprint,
            };
        case 'WISHLIST_FETCH_FAIL':
            return { ...state, loading: false };
        case 'WISHLIST_MUTATE_END':
            return { ...state, mutatingKey: null };
        case 'WISHLIST_REMOTE_SYNCED':
            return { ...state, remoteSyncNonce: state.remoteSyncNonce + 1 };
        default:
            return state;
    }
};
